import script from "./NotificationBell.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationBell.vue?vue&type=script&setup=true&lang=ts"

import "../assets/css/bell.css?vue&type=style&index=0&id=02ffb97d&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02ffb97d"]])

export default __exports__